/*
  assets/internal-ops.js — GLG-INTERNAL-OPS-03
  Owner: Internal Ops page interactions inside sections/internal-ops.liquid.
*/
(function () {
  'use strict';

  var VERSION = 'GLG-INTERNAL-OPS-03';
  var ROOT_SELECTOR = '[data-internal-provider-approvals]';
  var ASSIGNMENT_ROOT_SELECTOR = '[data-internal-assignments]';
  var mounted = new WeakSet();
  var assignmentMounted = new WeakSet();

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function isZh() {
    return clean(document.documentElement.lang).toLowerCase().indexOf('zh') === 0;
  }

  function copy() {
    return isZh()
      ? {
          loading: '正在载入供应商申请…',
          empty: '目前没有供应商申请。',
          error: '暂时无法读取供应商申请。',
          saving: '正在更新…',
          approve: '批准',
          reject: '拒绝',
          suspend: '暂停资格',
          note: '内部备注（可选）',
          account: '帐户',
          organization: '机构',
          applied: '申请时间',
          updated: '更新时间',
          pending: '待审批',
          approved: '已批准',
          rejected: '已拒绝',
          suspended: '已暂停',
          pending_assignment: '待分配',
          assigned: '已分配',
          reportWork: '报告工作',
          assignmentLoading: '正在载入报告工作…',
          assignmentEmpty: '目前没有待分配或已分配的报告工作。',
          assignmentError: '暂时无法读取工作分配。',
          assignmentSaving: '正在更新分配…',
          assignmentProvider: '当前供应商',
          assignmentAccepted: '接单状态',
          assignmentAssignedAt: '分配时间',
          assignmentSelect: '选择已批准供应商',
          assignmentManual: '分配给所选供应商',
          assignmentReassign: '重新分配',
          assignmentAuto: '自动分配',
          assignmentUnaccepted: '未确认接单',
          assignmentAcceptedYes: '已接单',
          activeWork: '处理中'
        }
      : {
          loading: 'Loading Provider applications…',
          empty: 'No Provider applications yet.',
          error: 'Provider applications are temporarily unavailable.',
          saving: 'Updating…',
          approve: 'Approve',
          reject: 'Reject',
          suspend: 'Suspend',
          note: 'Internal note (optional)',
          account: 'Account',
          organization: 'Organization',
          applied: 'Applied',
          updated: 'Updated',
          pending: 'Pending',
          approved: 'Approved',
          rejected: 'Rejected',
          suspended: 'Suspended',
          pending_assignment: 'Waiting for assignment',
          assigned: 'Assigned',
          reportWork: 'Report work',
          assignmentLoading: 'Loading report work…',
          assignmentEmpty: 'No report jobs are waiting for assignment or currently assigned.',
          assignmentError: 'Assignments are temporarily unavailable.',
          assignmentSaving: 'Updating assignment…',
          assignmentProvider: 'Current Provider',
          assignmentAccepted: 'Acceptance',
          assignmentAssignedAt: 'Assigned',
          assignmentSelect: 'Choose an approved Provider',
          assignmentManual: 'Assign selected Provider',
          assignmentReassign: 'Reassign',
          assignmentAuto: 'Auto assign',
          assignmentUnaccepted: 'Not accepted',
          assignmentAcceptedYes: 'Accepted',
          activeWork: 'active'
        };
  }

  function statusLabel(status, labels) {
    return labels[clean(status)] || clean(status) || '—';
  }

  function formatDate(value) {
    var raw = clean(value);
    if (!raw) return '—';
    var date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
      }).format(date);
    } catch (_error) {
      return raw;
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function setMessage(root, text, state) {
    var message = root.querySelector('[data-internal-provider-message]');
    if (!message) return;
    message.textContent = text || '';
    root.setAttribute('data-internal-provider-state', state || 'idle');
  }

  function actionButton(decision, text) {
    var button = element('button', 'portal-button internal-provider-approval__action', text);
    button.type = 'button';
    button.setAttribute('data-internal-provider-action', decision);
    return button;
  }

  function appendFact(container, label, value) {
    var row = element('div', 'internal-provider-approval__fact');
    row.appendChild(element('span', 'internal-provider-approval__fact-label', label));
    row.appendChild(element('strong', 'internal-provider-approval__fact-value', clean(value) || '—'));
    container.appendChild(row);
  }

  function renderItem(item, labels) {
    var card = element('article', 'internal-provider-approval__card');
    card.setAttribute('data-internal-provider-record', clean(item.customer_id));
    card.setAttribute('data-internal-provider-status', clean(item.status));

    var head = element('div', 'internal-provider-approval__card-head');
    var identity = element('div', 'internal-provider-approval__identity');
    identity.appendChild(element('strong', 'internal-provider-approval__provider', clean(item.provider_id) || 'Provider'));
    identity.appendChild(element('span', 'internal-provider-approval__account', labels.account + ': ' + (clean(item.customer_id) || '—')));
    head.appendChild(identity);
    head.appendChild(element('span', 'internal-provider-approval__status', statusLabel(item.status, labels)));
    card.appendChild(head);

    var facts = element('div', 'internal-provider-approval__facts');
    appendFact(facts, labels.organization, item.organization_id);
    appendFact(facts, labels.applied, formatDate(item.applied_at));
    appendFact(facts, labels.updated, formatDate(item.updated_at));
    card.appendChild(facts);

    var note = document.createElement('textarea');
    note.className = 'internal-provider-approval__note';
    note.rows = 2;
    note.maxLength = 800;
    note.placeholder = labels.note;
    note.setAttribute('data-internal-provider-note', '');
    card.appendChild(note);

    var actions = element('div', 'internal-provider-approval__actions');
    var status = clean(item.status);
    if (status === 'pending') {
      actions.appendChild(actionButton('approved', labels.approve));
      actions.appendChild(actionButton('rejected', labels.reject));
    } else if (status === 'approved') {
      actions.appendChild(actionButton('suspended', labels.suspend));
    } else if (status === 'rejected' || status === 'suspended') {
      actions.appendChild(actionButton('approved', labels.approve));
    }
    card.appendChild(actions);
    return card;
  }

  function renderList(root, items) {
    var list = root.querySelector('[data-internal-provider-list]');
    if (!list) return;
    var labels = copy();
    list.textContent = '';
    if (!Array.isArray(items) || !items.length) {
      list.appendChild(element('p', 'internal-provider-approval__empty', labels.empty));
      return;
    }
    items.forEach(function (item) {
      list.appendChild(renderItem(item || {}, labels));
    });
  }

  async function requestJson(root, options) {
    var endpoint = clean(root.getAttribute('data-internal-provider-endpoint'));
    if (!endpoint) throw new Error('missing_internal_provider_endpoint');
    var response = await fetch(endpoint, Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, options || {}));
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok || payload.ok === false) {
      var error = new Error(clean(payload.message || payload.error) || 'internal_provider_request_failed');
      error.status = response.status;
      throw error;
    }
    return payload;
  }

  async function load(root) {
    var labels = copy();
    setMessage(root, labels.loading, 'loading');
    try {
      var payload = await requestJson(root, { method: 'GET' });
      renderList(root, payload.items || []);
      setMessage(root, '', 'ready');
    } catch (_error) {
      renderList(root, []);
      setMessage(root, labels.error, 'error');
    }
  }

  async function decide(root, button) {
    var card = button.closest('[data-internal-provider-record]');
    if (!card) return;
    var customerId = clean(card.getAttribute('data-internal-provider-record'));
    var status = clean(button.getAttribute('data-internal-provider-action'));
    var note = card.querySelector('[data-internal-provider-note]');
    if (!customerId || !status) return;

    var labels = copy();
    Array.prototype.forEach.call(card.querySelectorAll('[data-internal-provider-action]'), function (node) {
      node.disabled = true;
    });
    setMessage(root, labels.saving, 'saving');

    try {
      await requestJson(root, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          customer_id: customerId,
          status: status,
          decision_note: clean(note && note.value)
        })
      });
      await load(root);
    } catch (_error) {
      setMessage(root, labels.error, 'error');
      Array.prototype.forEach.call(card.querySelectorAll('[data-internal-provider-action]'), function (node) {
        node.disabled = false;
      });
    }
  }

  function authorizeAndLoad(root) {
    var auth = window.GCityAuth;
    if (!auth || typeof auth.session !== 'function') return;
    Promise.resolve(auth.session()).then(function (state) {
      if (!state || state.authenticated !== true || state.role !== 'role_glg_internal') return;
      load(root);
    }).catch(function () {});
  }

  function mount(root) {
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    root.setAttribute('data-internal-provider-runtime', VERSION);

    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-internal-provider-action]');
      if (action) {
        event.preventDefault();
        decide(root, action);
        return;
      }
      var refresh = event.target.closest('[data-internal-provider-refresh]');
      if (refresh) {
        event.preventDefault();
        load(root);
      }
    });

    document.addEventListener('gcity:auth:ready', function (event) {
      var state = event && event.detail && event.detail.state;
      if (state && state.authenticated === true && state.role === 'role_glg_internal') load(root);
    });

    authorizeAndLoad(root);
  }

  function setAssignmentMessage(root, text, state) {
    var message = root.querySelector('[data-internal-assignment-message]');
    if (!message) return;
    message.textContent = text || '';
    root.setAttribute('data-internal-assignment-state', state || 'idle');
  }

  function assignmentFact(label, value) {
    var row = element('div', 'internal-assignment__fact');
    row.appendChild(element('span', 'internal-assignment__fact-label', label));
    row.appendChild(element('strong', 'internal-assignment__fact-value', clean(value) || '—'));
    return row;
  }

  function providerOptionLabel(provider, labels) {
    var identity = clean(provider.organization_id) || clean(provider.provider_id) || 'Provider';
    var count = Math.max(0, Number(provider.active_count || 0));
    return identity + ' · ' + count + ' ' + labels.activeWork;
  }

  function renderAssignmentCard(item, providers, labels) {
    var card = element('article', 'internal-assignment__card');
    card.setAttribute('data-internal-assignment-record', clean(item.job_id));
    card.setAttribute('data-internal-assignment-status', clean(item.status));

    var head = element('div', 'internal-assignment__card-head');
    var identity = element('div', 'internal-assignment__identity');
    identity.appendChild(element('strong', 'internal-assignment__job', labels.reportWork));
    identity.appendChild(element('span', 'internal-assignment__meta', clean(item.job_id) || '—'));
    head.appendChild(identity);
    head.appendChild(element('span', 'internal-assignment__status', statusLabel(item.status, labels)));
    card.appendChild(head);

    var facts = element('div', 'internal-assignment__facts');
    facts.appendChild(assignmentFact(labels.assignmentProvider, clean(item.provider_id) || '—'));
    facts.appendChild(assignmentFact(labels.assignmentAssignedAt, formatDate(item.assigned_at)));
    facts.appendChild(assignmentFact(labels.assignmentAccepted, item.accepted_at ? labels.assignmentAcceptedYes : labels.assignmentUnaccepted));
    card.appendChild(facts);

    var controls = element('div', 'internal-assignment__controls');
    var select = document.createElement('select');
    select.className = 'internal-assignment__select';
    select.setAttribute('data-internal-assignment-provider', '');
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = labels.assignmentSelect;
    select.appendChild(placeholder);
    (providers || []).forEach(function (provider) {
      var option = document.createElement('option');
      option.value = clean(provider.provider_id);
      option.textContent = providerOptionLabel(provider, labels);
      select.appendChild(option);
    });
    controls.appendChild(select);

    var actions = element('div', 'internal-assignment__actions');
    var manual = element('button', 'portal-button internal-assignment__action', item.provider_id ? labels.assignmentReassign : labels.assignmentManual);
    manual.type = 'button';
    manual.setAttribute('data-internal-assignment-action', 'manual');
    actions.appendChild(manual);
    var auto = element('button', 'portal-button internal-assignment__action', labels.assignmentAuto);
    auto.type = 'button';
    auto.setAttribute('data-internal-assignment-action', 'auto');
    actions.appendChild(auto);
    controls.appendChild(actions);
    card.appendChild(controls);
    return card;
  }

  function renderAssignments(root, payload) {
    var list = root.querySelector('[data-internal-assignment-list]');
    if (!list) return;
    var labels = copy();
    var jobs = Array.isArray(payload && payload.jobs) ? payload.jobs : [];
    var providers = Array.isArray(payload && payload.providers) ? payload.providers : [];
    list.textContent = '';
    if (!jobs.length) {
      list.appendChild(element('p', 'internal-assignment__empty', labels.assignmentEmpty));
      return;
    }
    jobs.forEach(function (item) {
      list.appendChild(renderAssignmentCard(item || {}, providers, labels));
    });
  }

  async function assignmentRequest(root, options) {
    var endpoint = clean(root.getAttribute('data-internal-assignment-endpoint'));
    if (!endpoint) throw new Error('missing_internal_assignment_endpoint');
    var response = await fetch(endpoint, Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, options || {}));
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok || payload.ok === false) {
      var error = new Error(clean(payload.message || payload.error) || 'internal_assignment_request_failed');
      error.status = response.status;
      throw error;
    }
    return payload;
  }

  async function loadAssignments(root) {
    var labels = copy();
    setAssignmentMessage(root, labels.assignmentLoading, 'loading');
    try {
      var payload = await assignmentRequest(root, { method: 'GET' });
      renderAssignments(root, payload || {});
      setAssignmentMessage(root, '', 'ready');
    } catch (_error) {
      renderAssignments(root, { jobs: [], providers: [] });
      setAssignmentMessage(root, labels.assignmentError, 'error');
    }
  }

  async function assignJob(root, button) {
    var card = button.closest('[data-internal-assignment-record]');
    if (!card) return;
    var jobId = clean(card.getAttribute('data-internal-assignment-record'));
    var mode = clean(button.getAttribute('data-internal-assignment-action')) === 'auto' ? 'auto' : 'manual';
    var select = card.querySelector('[data-internal-assignment-provider]');
    var providerId = clean(select && select.value);
    if (!jobId || (mode === 'manual' && !providerId)) return;

    var labels = copy();
    Array.prototype.forEach.call(card.querySelectorAll('[data-internal-assignment-action]'), function (node) {
      node.disabled = true;
    });
    setAssignmentMessage(root, labels.assignmentSaving, 'saving');

    try {
      await assignmentRequest(root, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          job_id: jobId,
          mode: mode,
          provider_id: mode === 'manual' ? providerId : undefined
        })
      });
      await loadAssignments(root);
    } catch (_error) {
      setAssignmentMessage(root, labels.assignmentError, 'error');
      Array.prototype.forEach.call(card.querySelectorAll('[data-internal-assignment-action]'), function (node) {
        node.disabled = false;
      });
    }
  }

  function authorizeAndLoadAssignments(root) {
    var auth = window.GCityAuth;
    if (!auth || typeof auth.session !== 'function') return;
    Promise.resolve(auth.session()).then(function (state) {
      if (!state || state.authenticated !== true || state.role !== 'role_glg_internal') return;
      loadAssignments(root);
    }).catch(function () {});
  }

  function mountAssignments(root) {
    if (!root || assignmentMounted.has(root)) return;
    assignmentMounted.add(root);
    root.setAttribute('data-internal-assignment-runtime', VERSION);

    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-internal-assignment-action]');
      if (action) {
        event.preventDefault();
        assignJob(root, action);
        return;
      }
      var refresh = event.target.closest('[data-internal-assignment-refresh]');
      if (refresh) {
        event.preventDefault();
        loadAssignments(root);
      }
    });

    document.addEventListener('gcity:auth:ready', function (event) {
      var state = event && event.detail && event.detail.state;
      if (state && state.authenticated === true && state.role === 'role_glg_internal') loadAssignments(root);
    });

    authorizeAndLoadAssignments(root);
  }

  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches(ROOT_SELECTOR)) mount(root);
    if (root.matches && root.matches(ASSIGNMENT_ROOT_SELECTOR)) mountAssignments(root);
    Array.prototype.forEach.call(root.querySelectorAll ? root.querySelectorAll(ROOT_SELECTOR) : [], mount);
    Array.prototype.forEach.call(root.querySelectorAll ? root.querySelectorAll(ASSIGNMENT_ROOT_SELECTOR) : [], mountAssignments);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
})();
